import { ReactComponent as LogoNotFound } from "assets/not-found.svg"
import React from "react"
import { Link } from "react-router-dom"

function NotFound() {
  return (
    <div className="d-flex align-center justify-center w-100v h-100v f-column">
      <LogoNotFound width="120" height="200" style={{ transform: "translate(10px) rotate(10deg)" }} />
      <h1 style={{ fontSize: "3rem" }}>Not Found</h1>
      <p>
        Back to the{" "}
        <Link to="/" className="primary-color">
          main page
        </Link>
      </p>
    </div>
  )
}

export default NotFound
